import { format, parseISO } from "date-fns";
import {
  getStartOfWeek,
  getEndOfWeek,
  getEachDayOfInterval,
  formattedDateBackend,
} from "../shared/formattedDate";

const options = { weekStartsOn: 1 };

export const weekDays = getEachDayOfInterval({
  start: getStartOfWeek({ options }),
  end: getEndOfWeek({ options }),
});

export const getFormattedDate = (dates: Date[] | string[]) => {
  return (
    Array.isArray(dates) &&
    dates?.map((date: Date | string) => formattedDateBackend(date))
  );
};

export const getStreakDates = (dates1, dates2) => {
  const matchingStreakDates = [];

  if (dates1 && dates2) {
    for (let i = 0; i < dates2.length; i += 1) {
      const date = dates2[i];
      // check if the date exists in dates1
      if (dates1.includes(date)) {
        matchingStreakDates.push(date);
      }
    }
  }

  return matchingStreakDates;
};

export const getDataStreak = (dates1: string[], dates2: string[]) => {
  const data = dates2.reduce((acc, current) => {
    const isStreak = dates1.includes(current);

    acc.push({
      date: current,
      isStreak,
      dayName: format(parseISO(current), "EEEEEE", { weekStartsOn: 1 }),
    });

    return acc;
  }, []);

  return data;
};
